<template>
  <div>
    <!-- <v-toolbar>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-side-icon class="hidden-md-and-up"></v-toolbar-side-icon> --
      <v-toolbar-items>
        <v-btn flat v-if="authenticated" :to="{ name: 'home' }">{{ $t('home') }}</v-btn>
        <template v-else>
          <v-btn flat :to="{ name: 'login' }">{{ $t('login') }}</v-btn>
          <v-btn flat :to="{ name: 'register' }">{{ $t('register') }}</v-btn>
        </template>
      </v-toolbar-items>
    </v-toolbar>-->
    <main>
      <v-content>
        <!-- <v-container fluid>
          <!-- <v-layout column align-center>
            <div class="display-3 grey--text mt-5">
              {{ title }}
            </div>

          </v-layout>--


        </v-container> -->
         <section id="welcome" class="hide-overflow">
            <v-layout>
              <v-flex hidden-sm-and-down md6>
                <v-img :src="require('../../img/welcome2ed.jpg')" height="100vh" />
              </v-flex>

              <v-flex
                xs12
                md6
                align-content-space-between
                layout
                :pa-5="$vuetify.breakpoint.smAndDown"
                wrap
              >
                <!-- <base-bubble-1 style="transform: rotate(180deg) translateY(25%)" /> -->

                <v-layout align-center justify-center>
                  <v-flex xs10 md6>
                    <!-- <base-heading>Welcome!</base-heading> -->
                    <!-- <base-text> -->
                     <login></login>
                    <!-- </base-text> -->
                    <!-- <base-btn class="mt-4">Learn More!</base-btn> -->
                  </v-flex>
                </v-layout>

                <!-- <base-bubble-2 style="transform: rotate(180deg) translate(-200px, -15%)" /> -->
              </v-flex>
            </v-layout>
          </section>
      </v-content>
    </main>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import login from './auth/adminlogin'
export default {
  name: "welcome-view",
  layout: "default",

  metaInfo() {
    return { title: this.$t("home") };
  },
  components:{
    login:login
  },
  computed: mapGetters({
    authenticated: "authCheck"
  }),

  data: () => ({
    title: window.config.appName
  })
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/welcome.vue